export const REGIONS = [
	'Filter By Region',
	'africa',
	'americas',
	'asia',
	'europe',
	'oceania',
];
